// src/config/routes.js

/*import all pages from components*/
import HomePage from "../components/pages/home/HomePage";
import About from "../components/pages/about/About";
import Articles from "../components/pages/articles/Articles";
import ArticlesDetails from "../components/pages/articles/ArticleDetails";
import EventDetails from "../components/pages/events/eventDetails/EventDetails";
import Events from "../components/pages/events/Events";
import LoginPage from "../components/pages/admin/LoginPage";
import ProfilePage from "../components/pages/admin/ProfilePage";
import ForgottenPassword from "../components/pages/admin/ForgottenPassword";
import ErrorPage from "../components/pages/404/Error";
import NewsPage from "../components/pages/news/news";
import QuizPage from "../components/pages/quiz/QuizPage";
import DhikrPage from "../components/pages/adhkar/adhkarPage";
import QuranPage from "../components/pages/quran/QuranPage";
import PrivacyPolicyPage from "../components/pages/privacy-policy/PrivacyPolicyPage";

/*Admin Pages*/
import CreateArticlePage from "../components/pages/admin/CreateArticle";
import AllArticlesPage from "../components/pages/admin/AllArticlesPage";
import CreateEventPage from "../components/pages/admin/CreateEvent";
import EventsPage from "../components/pages/admin/EventsPage";
import DashboardPage from "../components/pages/admin/dashboard";
import ImportEventsPage from "../components/pages/admin/ImportEventsPage";
import NotificationsPage from "../components/pages/admin/NotificationsPage";
import CreateNotificationPage from "../components/pages/admin/CreateNotification";
import MessagesPage from "../components/pages/admin/MessagesPage";

export const ROUTES = {
    HOME: { path: '/', component: HomePage, exact: true },
    LOGIN: { path: '/login', component: LoginPage },
    PROFILE: { path: '/profile', component: ProfilePage },
    FORGOTTEN_PASSWORD: { path: '/forgottenpassword', component: ForgottenPassword },
    DASHBOARD: { path: '/admin/dashboard', component: DashboardPage, isAdmin: true },
    CREATE_ARTICLE: { path: '/admin/articles/createarticle', component: CreateArticlePage, isAdmin: true },
    ALL_ARTICLES: { path: '/admin/articles/allarticles', component: AllArticlesPage, isAdmin: true },
    CREATE_EVENT: { path: '/admin/events/create', component: CreateEventPage, isAdmin: true },
    ALL_EVENTS: { path: '/admin/events/allevents', component: EventsPage, isAdmin: true },
    IMPORT_EVENTS: { path: '/admin/events/importevents', component: ImportEventsPage, isAdmin: true },
    ALL_NOTIFICATIONS: { path: '/admin/notifications/allnotifications', component: NotificationsPage, isAdmin: true },
    CREATE_NOTIFICATION: { path: '/admin/notifications/createnotification', component: CreateNotificationPage, isAdmin: true },
    ALL_MESSAGES: { path: '/admin/messages/allmessages', component: MessagesPage, isAdmin: true },
    ABOUT: { path: '/about', component: About },
    ARTICLES: { path: '/articles', component: Articles },
    ARTICLE_DETAILS: { path: '/article-details', component: ArticlesDetails },
    NEWS: { path: '/news', component: NewsPage },
    QUIZ: { path: '/quiz', component: QuizPage },
    DHIKR: { path: '/dhikr', component: DhikrPage },
    QURAN: { path: '/quran', component: QuranPage },
    PRIVACY_POLICY: { path: '/politique-de-confidentialite', component: PrivacyPolicyPage },
    EVENTS: { path: '/events', component: Events },
    EVENT_DETAILS: { path: '/event-details', component: EventDetails },
    ERROR: { component: ErrorPage },

};